import { useParams, useNavigate } from 'react-router-dom';
import { getSchemaBySlug } from '../engine/registry';
import { newUuid } from '../engine/uuid';
import { trackEvent } from '../engine/analytics';
import IntroIllustration from '../components/intro/IntroIllustration';
import NotFound from './NotFound';

export default function AssessmentIntro() {
  const { slug = '' } = useParams();
  const schema = getSchemaBySlug(slug);
  const navigate = useNavigate();
  if (!schema) return <NotFound />;

  const start = () => {
    const uuid = newUuid();
    sessionStorage.setItem(`assessment:${schema.id}:uuid`, uuid);
    sessionStorage.setItem(`assessment:${schema.id}:startedAt`, new Date().toISOString());
    sessionStorage.setItem(`assessment:${schema.id}:answers`, '{}');
    // Capture document.referrer so PostHog can attribute starts back to the
    // hub / service page / insight that drove them. Per the fractional-leadership
    // campaign plan, Phase 2 Task 13.
    trackEvent(`${schema.analytics.eventPrefix}_started`, {
      schema_id: schema.id,
      uuid,
      assessment_referrer_url: typeof document !== 'undefined' ? document.referrer || null : null,
    });
    navigate(`/${schema.slug}/q/1/`);
  };

  return (
    <article className="intro">
      <IntroIllustration />
      <p className="intro__eyebrow">
        {schema.estimatedMinutes} min · {schema.questions.length} questions · private
      </p>
      <h1 className="intro__title">{schema.title}</h1>
      <p className="intro__lede">{schema.description}</p>
      <button
        type="button"
        onClick={start}
        data-cta="assessment-start"
        data-cta-source="intro"
        className="intro__start"
      >
        Start now
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="intro__start-arrow"
        >
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      </button>
    </article>
  );
}
